
import { connect } from 'react-redux';
import BenchMaterialSelectionPage from '../components/BenchMaterialSelectionPage';
import { changeBenchMaterial, changeLinghtning, showInstructionModal } from '../actions';
import { getSelectableBenchMaterials } from '../reducers/materialStore';

const mapDispatchToProps = (dispatch, ownProps) => ({
    benchMaterialChanged: (e) => {
        dispatch(changeBenchMaterial(e.id));
    },
    lightingChanged: (e) => {
        dispatch(changeLinghtning(e.roofLight, e.benchLight, e.stoveLight,e.fibers));
    },
    showLightInstructions: () => {
        dispatch(showInstructionModal());
    }
});

const mapStateToProps = (state, ownProps) => {
    var benchMaterials = getSelectableBenchMaterials(state);
    return {
        benchMaterials: benchMaterials,
        benchMaterial: state.benchModel.material,
        nextPage: ownProps.nextPage,
        showPrices: state.clientConfiguration.showPrices,
        materialPrices: state.optionPricing.benchMaterials,
        light: state.saunaLighting,
        lightPrices: state.optionPricing.lights
    };
};

const BenchMaterialSelectionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(BenchMaterialSelectionPage);

export default BenchMaterialSelectionPageContainer;

